import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { deliveriesFromPropsSelector } from 'selectors/new-booking-selectors';
import { getUserCountryCodeFromState } from 'selectors/app-selector';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import OverlayBody from '../overlay-body';
import BulkServiceTypesSection from './bulk-service-type-section';
import BulkPickUpTimeSection from './bulk-pick-up-time-section';
import useBulkSelectedServiceTypeKey from '../common-logic/use-bulk-selected-service-type-key';

const BulkServiceConfigurationPanel = ({
  dispatch,
  onClose,
  deliveryIDs,
  deliveries,
  countryCode,
}) => {
  const onConfirm = useCallback(
    () => {
      onClose();
    },
    [onClose],
  );

  const onBack = useCallback(
    () => {
      onClose();
    },
    [onClose],
  );

  const selectedServiceTypeKey = useBulkSelectedServiceTypeKey(deliveries);

  return (
    <OverlayBody
      showConfirm
      disabledConfirm={!selectedServiceTypeKey}
      onConfirmClick={onConfirm}
      showHeader
      showTitle
      title={I18n.t('v2.anytimeBooking.serviceConfigurationPanelTitle')}
      showClose
      onClose={onBack}
    >
      <BulkServiceTypesSection
        dispatch={dispatch}
        deliveryIDs={deliveryIDs}
        deliveries={deliveries}
        countryCode={countryCode}
        selectedServiceTypeKey={selectedServiceTypeKey}
      />
      <BulkPickUpTimeSection
        dispatch={dispatch}
        selectedServiceTypeKey={selectedServiceTypeKey}
        deliveryIDs={deliveryIDs}
        deliveries={deliveries}
        countryCode={countryCode}
      />
    </OverlayBody>
  );
};

BulkServiceConfigurationPanel.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  countryCode: PropTypes.string.isRequired,
  deliveryIDs: PropTypes.arrayOf(PropTypes.string).isRequired,
  deliveries: PropTypes.arrayOf(NewBookingDeliveryPropType).isRequired,
};

export default connect((state, props) => ({
  deliveries: deliveriesFromPropsSelector(state, props),
  countryCode: getUserCountryCodeFromState(state),
}))(BulkServiceConfigurationPanel);
